import React, { useState } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';

interface RequestsFiltersProps {
  onFilterChange: (filter: string) => void;
  hideDropDownFilter: boolean;
  isPatientsView?: boolean; // Add this prop to differentiate between request and patient view
}

export const GridFilters = (props: RequestsFiltersProps) => {
  const [selectedFilter, setSelectedFilter] = useState<string>('all'); // The 'Show' filter state

  const onFilterChange = (newFilter: string) => {
    setSelectedFilter(newFilter);
    props.onFilterChange(newFilter); // Pass to the parent component (if needed)
  };

  return (
    <>
      <Row className='mb-3 align-items-center'>
        <Col>
          <span className='text-dark align-middle pe-2'>Show:</span>
          <Badge
            pill
            bg={selectedFilter === 'all' ? 'primary' : ''}
            className='mx-1'
            style={{
              cursor: 'pointer',
              justifyContent: 'space-between',
              gap: '3px',
              backgroundColor: selectedFilter === 'all' ? '' : '#E7F1FF',
              color: selectedFilter === 'all' ? '' : '#212529'
            }}
            onClick={() => onFilterChange('all')}>
            <i className='fa-light fa-folder pe-1'></i>
            All
          </Badge>
          <Badge
            pill
            bg={selectedFilter === 'actions' ? 'primary' : ''}
            className='mx-1'
            style={{
              cursor: 'pointer',
              justifyContent: 'space-between',
              gap: '3px',
              backgroundColor: selectedFilter === 'actions' ? '' : '#E7F1FF',
              color: selectedFilter === 'actions' ? '' : '#212529'
            }}
            onClick={() => onFilterChange('actions')}>
            <i className='fa-solid fa-triangle-exclamation pe-1'></i>
            Action Required
          </Badge>
          <Badge
            pill
            bg={selectedFilter === 'updates' ? 'primary' : ''}
            className='mx-1'
            style={{
              cursor: 'pointer',
              justifyContent: 'space-between',
              gap: '3px',
              backgroundColor: selectedFilter === 'updates' ? '' : '#E7F1FF',
              color: selectedFilter === 'updates' ? '' : '#212529'
            }}
            onClick={() => onFilterChange('updates')}>
            <i className='fa-light fa-history pe-1' />
            Updated
          </Badge>
          <Badge
            pill
            bg={selectedFilter === 'pending' ? 'primary' : ''}
            className='mx-1'
            style={{
              cursor: 'pointer',
              justifyContent: 'space-between',
              gap: '3px',
              backgroundColor: selectedFilter === 'pending' ? '' : '#E7F1FF',
              color: selectedFilter === 'pending' ? '' : '#212529'
            }}
            onClick={() => onFilterChange('pending')}>
            <i className='fa-light fa-stars pe-1'></i>
            Pending
          </Badge>
          {props.isPatientsView && (
            <>
              <Badge
                pill
                bg={selectedFilter === 'complete' ? 'primary' : ''}
                className='mx-1'
                style={{
                  cursor: 'pointer',
                  justifyContent: 'space-between',
                  gap: '3px',
                  backgroundColor: selectedFilter === 'complete' ? '' : '#E7F1FF',
                  color: selectedFilter === 'complete' ? '' : '#212529'
                }}
                onClick={() => onFilterChange('complete')}>
                <i className='fa-solid fa-badge-check pe-1'></i>
                Complete
              </Badge>
              <Badge
                pill
                bg={selectedFilter === 'enrollement' ? 'primary' : ''}
                className='mx-1'
                style={{
                  cursor: 'pointer',
                  justifyContent: 'space-between',
                  gap: '3px',
                  backgroundColor: selectedFilter === 'enrollement' ? '' : '#E7F1FF',
                  color: selectedFilter === 'enrollement' ? '' : '#212529'
                }}
                onClick={() => onFilterChange('enrollement')}>
                <i className='fa-solid fa-user-injured pe-1'></i>
                Incomplete Enrollment
              </Badge>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};
